import React from 'react';

interface BankIconProps {
  className?: string;
  height?: number;
}

export const BankIcon: React.FC<BankIconProps> = ({ className, height = 40 }) => (
  <svg
    width={height * (79 / 78)}
    height={height}
    viewBox="0 0 79 78"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    role="img"
    aria-label="Virement bancaire"
  >
    <path
      d={
        'M32.7303 50.5651L77.2975 50.5217C77.9552 50.5282 78.5382 50.7757 ' +
        '78.8478 51.3835C79.0507 59.9319 79.0507 68.5866 78.8478 77.1349' +
        'C78.551 77.6516 78.0791 78.0358 77.4577 77.9967H33.0058' +
        'C32.111 78.0575 31.5964 77.263 31.4917 76.449L31.5707 51.6614' +
        'C31.7608 51.0579 32.1388 50.741 32.7303 50.5651ZM47.26 56.4977' +
        'C47.26 54.5571 45.7118 52.9833 43.8027 52.9833C41.8936 52.9833 ' +
        '40.3454 54.5571 40.3454 56.4977C40.3454 58.4384 41.8936 60.0122 ' +
        '43.8027 60.0122C45.7118 60.0122 47.26 58.4384 47.26 56.4977' +
        'ZM54.0786 54.6374C53.2842 55.2887 53.8052 56.8993 54.9093 ' +
        '56.8689L73.3042 56.8733C75.1065 56.2894 74.5 54.2055 ' +
        '72.655 54.2662C67.107 54.607 61.0316 53.806 55.5478 54.2575' +
        'C55.1783 54.2879 54.3476 54.416 54.0807 54.6353L54.0786 54.6374' +
        'ZM54.6274 60.1489C53.1496 60.7394 53.502 62.604 55.0694 ' +
        '62.7169L72.9753 62.7126C74.752 62.6843 74.9079 60.3226 ' +
        '73.1397 60.1099L54.6274 60.1489ZM49.9977 68.0374C50.6575 67.371 ' +
        '49.3613 64.8355 48.8403 64.1735C46.235 60.8631 41.3853 60.8696 ' +
        '38.7651 64.1735C38.1117 64.9962 36.4161 68.1394 38.2847 68.2414' +
        'C41.806 68.0048 45.6883 68.5453 49.1649 68.2458C49.4147 68.2241 ' +
        '49.8183 68.2197 49.9977 68.0374ZM74.1263 68.0287C74.6538 67.3623 ' +
        '74.3185 65.8905 73.2978 65.96L54.7448 65.9535C53.4977 66.2205 ' +
        '53.3696 67.5772 54.3562 68.3152L73.5754 68.3543C73.6843 68.3304 ' +
        '74.0601 68.1112 74.1263 68.0265V68.0287ZM36.1193 71.643V74.2565' +
        'H74.3506V71.643H36.1193Z'
      }
      fill="#00AD00"
    />
    <path
      d={
        'M34.2123 31.3541L34.853 47.9277C32.7645 47.7562 30.3813 48.1491 ' +
        '29.4374 50.3046C29.2794 50.665 28.9377 51.7438 28.9377 52.0716' +
        'V61.5773H24.3016L25.4206 31.3541H34.2123Z'
      }
      fill="#8D8D8D"
    />
    <path d="M18.0682 31.3541L19.1872 61.5773H8.15748L9.27647 31.3541H18.0682Z" fill="#8D8D8D" />
    <path
      d={'M28.9377 69.0511V74.0872H0.00427093C0.459125 72.4049 0.948147 ' + '70.5967 1.68275 69.0511H28.9377Z'}
      fill="#8D8D8D"
    />
    <path
      d={'M28.9377 64.0128V66.6134H5.12085C5.19346 65.7429 5.67394 ' + '64.7487 6.16082 64.0128H28.9398H28.9377Z'}
      fill="#8D8D8D"
    />
    <path
      d={
        'M75.7728 19.9816L74.2374 23.5655H1.67634L1.42649 23.4548' +
        'L0 20.0685L37.8063 0C50.5465 6.48833 63.024 13.5193 ' +
        '75.7728 19.9816ZM44.9131 12.6359C44.9131 8.68511 41.7612 ' +
        '5.48111 37.8746 5.48111C33.9881 5.48111 30.8361 8.68511 ' +
        '30.8361 12.6359C30.8361 16.5866 33.9881 19.7906 37.8746 19.7906' +
        'C41.7612 19.7906 44.9131 16.5866 44.9131 12.6359Z'
      }
      fill="#8D8D8D"
    />
    <path
      d={
        'M70.0177 26.153L68.9606 28.7623H6.95308C6.82709 28.7861 ' +
        '6.77584 28.7492 6.70323 28.6515C6.38291 28.2304 5.99639 ' +
        '26.7283 5.76149 26.153H70.0198H70.0177Z'
      }
      fill="#8D8D8D"
    />
    <path d="M50.3564 31.3541L50.9971 47.9277H40.9262L41.5647 31.3541H50.3564Z" fill="#8D8D8D" />
    <path d="M66.5027 31.3541L67.1412 47.9277H57.0704L57.711 31.3541H66.5027Z" fill="#8D8D8D" />
    <path
      d={
        'M39.2029 8.57007C39.2413 8.62651 39.7474 8.80233 39.9738 9.00638' +
        'C41.0714 9.99841 40.7831 11.3855 39.3289 11.6113C40.8301 12.4535 ' +
        '41.3085 14.5157 40.1959 15.905C39.914 16.2566 39.4015 16.4781 ' +
        '39.2563 16.7364C38.8591 17.4375 39.0491 18.3688 37.6654 18.1886' +
        'C36.5848 18.0475 36.8496 17.2204 36.5699 16.7733C36.4951 16.6561 ' +
        '35.8096 16.3674 35.5641 16.0895C34.6287 15.0237 35.0964 14.0577 ' +
        '36.288 13.5628C34.8999 12.7683 34.5561 10.7972 35.4936 9.50131' +
        'C35.7264 9.18004 36.54 8.63302 36.5741 8.57007C36.8795 8.02087 ' +
        '36.5229 7.10048 37.8362 7.03101C39.0705 6.96589 38.9274 8.16848 ' +
        '39.205 8.57224L39.2029 8.57007Z'
      }
      fill="#8D8D8D"
    />
  </svg>
);
